import React from 'react';
import { bool, string } from 'prop-types';
import { Link } from 'react-router-dom';
import { SubBodyText } from '../Text';

const isExternalLink = link => {
  return /^https?:\/\//.test(link);
};

const BreadcrumbLink = ({ link, label, isFirst }) => {
  if (isFirst || isExternalLink(link)) {
    return (
      <a href={link}>
        <SubBodyText color="greyDark">{label}</SubBodyText>
      </a>
    );
  }

  return (
    <Link to={link}>
      <SubBodyText color="greyDark">{label}</SubBodyText>
    </Link>
  );
};

BreadcrumbLink.propTypes = {
  link: string.isRequired,
  label: string.isRequired,
  isFirst: bool,
};
BreadcrumbLink.defaultProps = { isFirst: false };

export default BreadcrumbLink;
